module.exports = __webpack_public_path__ + "img/1575a57fd11caa0a7746bd4da210949b.png";